import React from "react";
import { Link , useNavigate} from "react-router-dom";
import arrowLeft from "../../assets/icons/common/arrowLeft.svg";

const Index = ({title }) => {
    const navigate = useNavigate(); 

  const goBack = () => {
    navigate(-1)
  };

  return (
    <Link to="#" onClick={goBack}>
      <div className="border-b-[2px] border-[#34BD5A] py-[12px]">
        <div className="flex items-center px-[16px]">
          <img src={arrowLeft} alt="" />
          <h3 className="text-[16px] font-semibold pl-[12px]">{title}</h3>
        </div>
      </div>
    </Link>
  );
};

export default Index;
